module.exports = __webpack_public_path__ + "img/ring_y_e_0_1@2x.252d885b.png";